<template>
  <el-col>
    <el-table
      v-loading="users == null"
      :height="windowHeight - 238"
      @selection-change="handleSelectionChange"
      @row-click="editUser"
      :data="users"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        label="Name"
        :fixed="$mq === 'xs' ? false : 'left'"
        sortable
        prop="firstName"
        min-width="150"
      >
        <template slot-scope="scope">{{ getFullName(scope.row) }}</template>
      </el-table-column>
      <el-table-column
        label="Class"
        :fixed="$mq === 'xs' ? false : 'left'"
        sortable
        prop="level.o_id"
        align="center"
        :filters="levelFilters"
        :filter-method="levelFilter"
        min-width="100"
      >
        <template slot-scope="scope">{{ scope.row.level.name }}</template>
      </el-table-column>
      <el-table-column label="Username" sortable prop="un" min-width="115"></el-table-column>
      <el-table-column label="Position" sortable prop="primary_position" min-width="300">
        <template
          slot-scope="scope"
        >{{ scope.row.primary_position != null ? scope.row.primary_position.name : ' '}}</template>
      </el-table-column>
    </el-table>
    <div class="clearfix">
      <el-row type="flex" style="margin: 8px; justify-content: flex-end;" class="bottom">
        <el-button
          v-if="multipleSelection.length != 0"
          @click="showDeleteDialog"
          icon="el-icon-delete"
          type="danger"
          size="small"
        ></el-button>
        <el-button
          @click="dialogUploadVisible = true"
          type="primary"
          size="small"
          icon="el-icon-picture-outline"
        ></el-button>
        <el-button @click="newUser" type="primary" size="small" icon="el-icon-plus"></el-button>
      </el-row>
    </div>

    <el-dialog
      title="Upload Profile Pictures"
      :visible.sync="dialogUploadVisible"
      :fullscreen="$mq === 'xs'"
      v-loading="uploadLoading"
    >
      <el-upload
        ref="upload"
        drag
        action="/api/v1/users/uploadBatchPP"
        :headers="{'Accept': 'application/json', 'X-CSRF-TOKEN': $csrfToken}"
        :on-error="uploadError"
        :on-success="uploadSuccess"
        :multiple="true"
        :auto-upload="true"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Drop file here or
          <em>click to upload</em>
        </div>
        <div
          class="el-upload__tip"
          slot="tip"
        >Upload zip file containing .jpg images named after the applicable username or individual .jpg images.</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogUploadVisible = false">Close</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Add User" :visible.sync="dialogNewVisible" :fullscreen="$mq === 'xs'">
      <el-form :label-position="labelPosition" :model="newp">
        <el-form-item label="RIT Username" :label-width="formLabelWidth">
          <el-input v-model="newp.un" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="levels != null" label="AS Level" :label-width="formLabelWidth">
          <el-select v-model="newp.level" value-key="o_id" placeholder="Please select an AS Level">
            <el-option
              v-for="level in levels"
              :key="level.o_id"
              :label="level.name"
              :value="level.o_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Rank" :label-width="formLabelWidth">
          <el-select
            v-if="ranks != null"
            v-model="newp.rank"
            value-key="o_id"
            placeholder="Please select a rank"
          >
            <el-option v-for="rank in ranks" :key="rank.o_id" :label="rank.name" :value="rank.o_id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogNewVisible = false">Cancel</el-button>
        <el-button type="primary" @click="saveUser(newp)">Save</el-button>
      </span>
    </el-dialog>

    <el-dialog width="80%" title="Edit User" :visible.sync="dialogEditVisible" :fullscreen="$mq === 'xs'">
      <el-row :gutter="16">
        <el-col :xs="24" :sm="14" style="height: 100%">
          <div class="section-header">
            <div class="title">Info</div>
            <div class="divider"></div>
          </div>
          <div style="padding-right: 16px; height: 100%;">
            <div class="flex">
              <span class="mgra sub-header">ID</span>
              <span>{{ newp.o_id }}</span>
            </div>
            <div class="flex">
              <span class="mgra sub-header">Name</span>
              <span>{{ getFullName(newp) }}</span>
            </div>
            <div class="flex">
              <span class="mgra sub-header">Username</span>
              <span>{{ newp.un }}</span>
            </div>
            <div class="flex">
              <span class="mgra sub-header">Image</span>
              <span>{{ newp.image_uri }}</span>
            </div>
          </div>
          <div class="section-header">
            <div class="title">Biography</div>
            <div class="divider"></div>
          </div>
          <vue-editor v-loading="newp.bio == null" v-model="newp.bio" :editorOptions="editorOption"></vue-editor>
        </el-col>
        <el-col :xs="24" :sm="10">
          <el-form label-position="top" :model="newp">
            <el-form-item label="UID" :label-width="formLabelWidth">
              <el-input v-model="newp.uid" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item v-if="levels != null" label="AS Level" :label-width="formLabelWidth">
              <el-select
                v-model="newp.level"
                value-key="o_id"
                style="width: 100%"
                placeholder="Please select an AS Level"
              >
                <el-option
                  v-for="level in levels"
                  :key="level.o_id"
                  :label="level.name"
                  :value="level"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Rank" :label-width="formLabelWidth">
              <el-select
                v-if="ranks != null"
                v-model="newp.rank"
                value-key="o_id"
                style="width: 100%"
                placeholder="Please select a rank"
              >
                <el-option v-for="rank in ranks" :key="rank.o_id" :label="rank.name" :value="rank"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Position" :label-width="formLabelWidth">
              <el-select
                v-if="positions != null"
                v-model="newp.primary_position"
                style="width: 100%"
                value-key="o_id"
                placeholder="Please select a position"
              >
                <el-option label="None" :value="null"></el-option>
                <el-option
                  v-for="position in positions"
                  :key="position.o_id"
                  :label="position.name"
                  :value="position"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Major" :label-width="formLabelWidth">
              <el-input v-model="newp.major" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="School" :label-width="formLabelWidth">
              <el-input v-model="newp.school" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Hometown" :label-width="formLabelWidth">
              <el-input v-model="newp.hometown" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Phone" :label-width="formLabelWidth">
              <el-input v-model="newp.phone" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEditVisible = false">Cancel</el-button>
        <el-button type="primary" @click="saveUser(newp)">Save</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Confirm User Deletion" v-loading="deleteLoading" :visible.sync="deleteDialogVisible" width="30%" style="text-align: center;" center :fullscreen="$mq === 'xs'">
      <span>Are you sure you want to delete these users?</span>
      <div style="max-height: 200px; overflow: auto;">
        <ul style="text-align: center; padding: 0; list-style: none;">
          <li v-for="user in multipleSelection" v-bind:key="user.o_id">{{user.firstName + ' ' + user.lastName}}</li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">No</el-button>
        <el-button type="danger" @click="deleteUsers">Confirm</el-button>
      </span>
    </el-dialog>
  </el-col>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import {VueEditor} from "vue2-editor";

export default {
    components: {VueEditor},
    data() {
        return {
            newp: [],
            deleteLoading: false,
            multipleSelection: [],
            formLabelWidth: "140px",
            dialogNewVisible: false,
            dialogEditVisible: false,
            deleteDialogVisible: false,
            dialogUploadVisible: false,
            uploadLoading: false,
            delUser: {
                name: null,
                o_id: null
            },
            window: {
                width: 0,
                height: 0
            },
            editorOption: {
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "link"],
                        [{indent: "-1"}, {indent: "+1"}],
                        [{list: "ordered"}, {list: "bullet"}]
                    ]
                },
                placeholder: "Write about yourself here..."
            }
        };
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    computed: {
        ...mapFields(["user", "users", "levels", "ranks", "positions"]),
        labelPosition() {
            return this.$mq == "xs" ? "top" : "left";
        },
        levelFilters() {
            var t = [];
            if (this.levels == null) return t;
            this.levels.map((level) => {
                t.push({text: level.name, value: level.o_id});
            });
            return t;
        }
    },
    mounted() {
        if (this.ranks == null) this.$store.dispatch("pullRanks");
        if (this.levels == null) this.$store.dispatch("pullLevels");
        if (this.positions == null) this.$store.dispatch("pullPositions");
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        levelFilter(value, row) {
            return row.level.o_id === value;
        },
        uploadSuccess(response) {
            if(response.success != null && response.success.length > 0){
                response.success.forEach((e) => {
                    Object.keys(e).forEach((key) =>
                        this.$message({
                            showClose: true,
                            message: key + ': '+e[key],
                            type: "success"
                        }));});
            }
            if(response.errors != null && response.errors.length > 0){
                response.errors.forEach((e) => {
                    Object.keys(e).forEach((key) =>
                        this.$message({
                            showClose: true,
                            message: key + ': '+e[key],
                            type: "error"
                        }));});
            }
        },
        uploadError(err, file) {
            this.$message({
                showClose: true,
                message: file + ': ' + err,
                type: "error"
            });
        },
        getUID() {
            this.axios
                .get("/api/v1/users/" + this.newp.o_id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.$set(this.newp, "uid", response.data.uid);
                })
                .catch((err) => {
                    console.error(err);
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: "error"
                    });
                });
        },
        getBio() {
            this.axios
                .get("/api/v1/userbio/" + this.newp.o_id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.$set(this.newp, "bio", response.data.bio);
                })
                .catch((err) => {
                    console.error(err);
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: "error"
                    });
                });
        },
        newUser() {
            this.newp = {
                un: null,
                o_id: null,
                level: null,
                rank: null
            };
            this.dialogNewVisible = true;
        },
        editUser(user) {
            this.newp = JSON.parse(JSON.stringify(user));
            this.getBio();
            this.getUID();
            this.dialogEditVisible = true;
        },
        saveUser() {
            var route = "";
            if (this.newp.o_id != null) {
                route = "/api/v1/users/" + this.newp.o_id;
                if (this.newp.bio != null && this.newp.bio != "") {
                    this.axios
                        .put(
                            "/api/v1/userbio/" + this.newp.o_id,
                            {bio: this.newp.bio},
                            {
                                headers: {"Content-Type": "application/json"},
                                credentials: "same-origin"
                            }
                        )
                        .catch((err) => {
                            console.error(err);
                            var terr = err;
                            if (err.response) {
                                terr = err.response.data.errors;
                            }
                            this.$message({
                                showClose: true,
                                message: terr,
                                type: "error"
                            });
                        });
                }
                this.axios
                    .put(
                        route,
                        this.newp.uid == null || this.newp.uid == "withheld"
                            ? {
                                level: this.newp.level.o_id,
                                rank: this.newp.rank.o_id,
                                primary_position:
                    this.newp.primary_position != null
                        ? this.newp.primary_position.o_id
                        : null,
                                major: this.newp.major,
                                school: this.newp.school,
                                hometown: this.newp.hometown,
                                phone: this.newp.phone
                            }
                            : {
                                uid: this.newp.uid,
                                level: this.newp.level.o_id,
                                rank: this.newp.rank.o_id,
                                primary_position:
                    this.newp.primary_position != null
                        ? this.newp.primary_position.o_id
                        : null,
                                major: this.newp.major,
                                school: this.newp.school,
                                hometown: this.newp.hometown,
                                phone: this.newp.phone
                            },
                        {
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin"
                        }
                    )
                    .then((response) => {
                        var temp = this.users.find((objv) => objv.o_id == response.data.o_id);
                        var index = this.users.indexOf(temp);
                        this.users.splice(index, 1, response.data);

                        this.$message({
                            showClose: true,
                            message: "User saved successfuly.",
                            type: "success"
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: err.response.data.errors.title,
                            type: "error"
                        });
                    });

                this.dialogEditVisible = false;
            } else {
                route = "/api/v1/users";
                this.axios
                    .post(route, JSON.stringify(this.newp), {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    })
                    .then((response) => {
                        this.users.push(response.data);
                        this.$message({
                            showClose: true,
                            message: "User created successfuly",
                            type: "success"
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: "There was an error finding the user.",
                            type: "error"
                        });
                    });
            }
        },
        showDeleteDialog() {
            this.deleteDialogVisible = true;
        },

        deleteUsers() {
            this.deleteLoading = true;
            this.multipleSelection.forEach((user) => {
                this.axios
                    .delete("/api/v1/users/" + user.o_id, {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    })
                    .then(() => {
                        this.$message({
                            showClose: true,
                            message: "User deleted successfuly",
                            type: "success"
                        });
                        var temp = this.users.find((objv) => objv.o_id == user.o_id);
                        var index = this.users.indexOf(temp);
                        this.users.splice(index, 1);
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: err.response.data.errors.title,
                            type: "error"
                        });
                    });
            });
            this.deleteLoading = false;
            this.deleteDialogVisible = false;
        }
    }
};
</script>
